import { useNavigate } from 'react-router-dom';
import Card, { CardHeader } from '@/components/ui/Card';
import Button from '@/components/ui/Button';

/**
 * Connections settings component
 * Links to the main connections page for managing bank connections
 */
export default function ConnectionsSettings() {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader
        title="Connected Accounts"
        description="Manage your linked financial institutions"
      />

      <div className="text-center py-8">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          />
        </svg>

        <h3 className="mt-2 text-sm font-medium text-gray-900">
          Manage your bank connections
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Connect new accounts, update existing connections, or remove accounts you no longer need.
        </p>

        <div className="mt-6">
          <Button onClick={() => navigate('/connections')}>
            Manage Connections
          </Button>
        </div>
      </div>

      <div className="mt-6 pt-6 border-t border-gray-100">
        <h4 className="text-sm font-medium text-gray-900 mb-3">Quick tips</h4>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
            </svg>
            <span>
              <strong>Keep connections up to date</strong> - If a connection shows an error, you may need to re-authenticate with your bank.
            </span>
          </li>
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
            </svg>
            <span>
              <strong>Secure by design</strong> - We never store your bank login credentials. All connections use secure, bank-approved methods.
            </span>
          </li>
          <li className="flex items-start gap-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
            </svg>
            <span>
              <strong>Hidden accounts</strong> - You can hide accounts you do not want to track without disconnecting them.
            </span>
          </li>
        </ul>
      </div>
    </Card>
  );
}
